import React from 'react';
import { CircleRunningIcon } from '../IconProvider';
const ButtonLoader = ({ title }) => {
  return (
    <div className="flex items-center gap-2">
      <CircleRunningIcon />
      {title}
    </div>
  );
};

export default ButtonLoader;
